import { render, staticRenderFns } from "./ButtonsWidgets.vue?vue&type=template&id=3f2d4a7a&"
import script from "./ButtonsWidgets.vue?vue&type=script&lang=ts&"
export * from "./ButtonsWidgets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports